import React, { useState, useCallback } from "react";
import { showAlert } from "../utils/alert";

const Recovery = () => {
  const [formData, setFormData] = useState({
    username: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (isSubmitting) return;

    const { username } = formData;

    if (!username) {
      showAlert("Por favor, ingrese su número de documento.", "warning");
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await fetch("/api/requestPasswordReset", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username }),
      });

      const data = await response.json();

      if (data.response === "1") {
        showAlert(
          "Se ha enviado un correo con la nueva contraseña!",
          "success"
        );
        setTimeout(() => {
          window.location.href = "/login";
        }, 2000);
      } else {
        showAlert(data.data.msg || "Error al recuperar contraseña", "error");
      }
    } catch (error) {
      showAlert(
        error instanceof Error ? error.message : "Error en la recuperación",
        "error"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="flex h-screen flex-col items-center justify-center bg-pink-950">
      <div className="z-10 w-full max-w-sm px-12">
        <img
          src="/logo.png"
          alt="logo"
          className="mb-4 w-50 h-50 mx-auto object-contain"
        />
        <h1 className="text-white text-xl font-bold text-center pb-2">
          Recuperar Contraseña
        </h1>
        <form className="flex flex-col gap-5 pt-5" onSubmit={handleSubmit}>
          <input
            type="text"
            name="username"
            placeholder="Número de Documento"
            className="text-black p-2 rounded-md focus:outline-none focus:ring-4 focus:ring-pink-800 focus:border-pink-800"
            value={formData.username}
            onChange={handleChange}
            disabled={isSubmitting}
          />
          <button
            type="submit"
            className={`bg-yellow-500 text-white p-2 rounded-md transition-colors flex items-center justify-center h-10 ${
              isSubmitting
                ? "opacity-50 cursor-not-allowed"
                : "hover:bg-yellow-600"
            }`}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Enviando..." : "Recuperar Contraseña"}
          </button>
          <button
            type="button"
            onClick={() => (window.location.href = "/login")}
            className="bg-gray-500 text-white p-2 rounded-md transition-colors hover:bg-gray-600"
            disabled={isSubmitting}
          >
            Volver al Login
          </button>
        </form>
      </div>
    </main>
  );
};

export default Recovery;
